"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Link from "next/link";
import { FC } from "react";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import useMediaQuery from "@/hooks/useMediaQuery";
import { StorytellingCarouselProps } from "@/types";

import StorytellingCarouselCard from "./StorytellingCarouselCard";
import "./Storytellingcarousel.css";

SwiperCore.use([Pagination, Navigation]);

const StorytellingCarousel: FC<StorytellingCarouselProps> = ({ entry }) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const locale = useLocale();
  return (
    <>
      <div className={`w-full pt-[40px] pb-0  storytelling-carousel ${isDesktop ? "pl-[10px] pr-[10px]" : ""}`}>
        {isDesktop ? (
          <>
            <Swiper
              navigation={true}
              pagination={{ el: ".pagination-storytelling-carousel", clickable: true }}
              className="w-full"
              spaceBetween={30}
              slidesPerView={3}
              centeredSlides={false}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              {entry.cards?.map((item, index) => (
                <SwiperSlide key={`storytelling-carousel-${index}`}>
                  {item.cta ? (
                    <Link href={getLink(item.cta, locale)} target={item.cta?.link?.target ? "_blank" : "_self"}>
                      <StorytellingCarouselCard {...item} />
                    </Link>
                  ) : (
                    <StorytellingCarouselCard {...item} />
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="pagination-storytelling-carousel flex items-center justify-center h-[40px]"></div>
          </>
        ) : (
          <div className="w-full px-m">
            {entry.cards?.map((item, index) => (
              <div key={`storytelling-carousel-${index}`} className="pb-l">
                {item.cta ? (
                  <Link href={getLink(item.cta, locale)} target={item.cta?.link?.target ? "_blank" : "_self"}>
                    <StorytellingCarouselCard {...item} />
                  </Link>
                ) : (
                  <StorytellingCarouselCard {...item} />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
export default StorytellingCarousel;
